module.exports = __webpack_public_path__ + "static/media/RezeptSalzteig.368ec19c.pdf";